import { useDispatch, useSelector } from "react-redux";
import { downloadTradeReviewReport } from "../thunks/downloadReport";
import React from "react";
import { StoreType } from "../../../../../core/store/reducers";
import { FetchStateType } from "../../../../models";

export const useTradeViewReportDownloader = () => {
  const fetchState = useSelector<StoreType, FetchStateType>(
    (s) => s.data.reports.exchbusiness.tradeReview.downloadReportFetchState
  );
  const dispatch = useDispatch();
  const download = React.useCallback(
    () => dispatch(downloadTradeReviewReport()),
    [dispatch]
  );

  return [download, fetchState] as [typeof download, typeof fetchState];
};
